eSocial.FormatadorDeXml = (function() {

    function formatXml3Th(xml) {
        var formatted = '';
        var reg = /(>)(<)(\/*)/g;
        xml = xml.replace(reg, '$1\r\n$2$3');
        var pad = 0;
        jQuery.each(xml.split('\r\n'), function (index, node) {
            var indent = 0;
            if (node.match(/.+<\/\w[^>]*>$/)) {
                indent = 0;
            } else if (node.match(/^<\/\w/)) {
                if (pad !== 0) {
                    pad -= 1;
                }
            } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
                indent = 1;
            } else {
                indent = 0;
            }

            var padding = '';
            for (var i = 0; i < pad; i++) {
                padding += '    ';
            }

            formatted += padding + node + '\r\n';
            pad += indent;
        });

        return formatted;
    }
    
    function formatTextArea(obj) {
        var content = formatXml3Th(obj.value);
        obj.value = content;
    }
    
    function formatXml() {
        $('.esxmlformat').each(function(index, obj) {
            if (obj.value == null || $.trim(obj.value) == '')
                return;
            formatTextArea(obj);
        });
    }

    function formatXmlAce() {
        $('.source-editor').each(function () {
            var div = $(this);
            var mode = div.data('mode');

            if (!mode)
                return;

            var field = div.data('bind-field');
            var editor = window.ace.edit(div[0]);
            editor.setTheme("ace/theme/chrome");
            editor.setPrintMarginColumn(-1);
            editor.getSession().setMode("ace/mode/" + mode);
            editor.getSession().setUseWrapMode(true);
            editor.setReadOnly(true);
            editor.setOptions({
                enableBasicAutocompletion: true,
                enableSnippets: true,
                enableLiveAutocompletion: true
            });
            editor.focus();

            if (!field)
                return;

            var xmlFormated = formatXml3Th(editor.getSession().getValue());
            editor.getSession().setValue(xmlFormated);
        });
    }

    return {
        formatXml: formatXml,
        formatXmlAce: formatXmlAce,
        formatXml3Th: formatXml3Th
    }
})();